module.exports = __webpack_public_path__ + "media/theme/icon__congratulations-4bea82e0.svg";